import { render } from "./TransactionListComponent.vue?vue&type=template&id=1db4aa52&scoped=true"
import script from "./TransactionListComponent.vue?vue&type=script&lang=js"
export * from "./TransactionListComponent.vue?vue&type=script&lang=js"

import "./TransactionListComponent.vue?vue&type=style&index=0&id=1db4aa52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db4aa52"]])

export default __exports__